(function () {
  function getSourceValue(sourceInput) {
    if (sourceInput.tagName === 'SELECT') return sourceInput.value;
    if (sourceInput.type === 'radio') {
      var radios = document.querySelectorAll('input[name="' + sourceInput.name + '"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) return radios[i].value;
      }
    }
    return null;
  }

  function setSourceValue(sourceInput, value) {
    if (sourceInput.tagName === 'SELECT') {
      sourceInput.value = value;
      sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (sourceInput.type === 'radio') {
      var radios = document.querySelectorAll('input[name="' + sourceInput.name + '"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === value) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
  }

  function findVariantPickerInput(variantPicker, optionName) {
    var select = variantPicker.querySelector('select[name="options[' + optionName + ']"]');
    if (select) return select;
    var radio = variantPicker.querySelector('input[name="' + optionName + '"]');
    if (radio) return radio;
    return null;
  }

  function findSourceInput(optionName, pyoOneRow, variantPicker) {
    if (pyoOneRow) {
      var isSize = optionName.toLowerCase().indexOf('size') !== -1;
      var el = isSize
        ? pyoOneRow.querySelector('[data-pyo-size]')
        : pyoOneRow.querySelector('[data-pyo-color]');
      if (el) return el;
    }
    if (variantPicker) {
      var input = findVariantPickerInput(variantPicker, optionName);
      if (input) return input;
    }
    return null;
  }

  function updateStickyImage(pyoOneRow) {
    if (!pyoOneRow) return;
    var pyoRoot = pyoOneRow.closest('pick-your-offer');
    if (!pyoRoot) return;
    var variantId = pyoOneRow.dataset.variantId;
    if (!variantId) return;
    var variantsScript = pyoRoot.querySelector('[data-pyo-variants]');
    if (!variantsScript) return;
    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }
    var variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;
    var src = variant.featured_image.src;
    ['selectedVariantImage-desktop', 'selectedVariantImage-mobile'].forEach(function (id) {
      var img = document.getElementById(id);
      if (img && img.src !== src) img.src = src;
    });
  }

  function setupPill(pill, pyoOneRow, variantPicker) {
    if (pill.dataset.pillReady === 'true') return;

    var optionName = pill.getAttribute('data-sticky-pill-option');
    if (!optionName) return;

    var sourceInput = findSourceInput(optionName, pyoOneRow, variantPicker);
    if (!sourceInput) return;

    pill.dataset.pillReady = 'true';

    var initialValue = getSourceValue(sourceInput);
    if (initialValue) pill.value = initialValue;

    sourceInput.addEventListener('change', function () {
      var value = getSourceValue(sourceInput);
      if (value != null && pill.value !== value) pill.value = value;
      updateStickyImage(pyoOneRow);
    });

    pill.addEventListener('change', function () {
      setSourceValue(sourceInput, pill.value);
      updateStickyImage(pyoOneRow);
    });
  }

  var offerVisibilityReady = false;

  function setupOfferVisibility() {
    var offerCards = document.querySelectorAll('[data-pyo-card]');
    if (!offerCards.length) return;

    function updateVisibility() {
      var twoCard = document.querySelector('[data-pyo-card="two"]');
      var isTwo = !!(twoCard && twoCard.classList.contains('is-active'));
      document.querySelectorAll('[data-sticky-atc-picker]').forEach(function (wrapper) {
        wrapper.hidden = isTwo;
      });
    }

    updateVisibility();

    if (offerVisibilityReady) return;
    offerVisibilityReady = true;
    offerCards.forEach(function (card) {
      card.addEventListener('click', updateVisibility);
    });
  }

  function init() {
    var wrappers = document.querySelectorAll('[data-sticky-atc-picker]');
    if (!wrappers.length) return;

    var pyoOneRow = document.querySelector('[data-pyo-rows="one"] [data-pyo-row]');
    var variantPicker = document.querySelector('variant-selects, variant-radios');

    wrappers.forEach(function (wrapper) {
      var pills = wrapper.querySelectorAll('[data-sticky-pill-option]');
      pills.forEach(function (pill) {
        setupPill(pill, pyoOneRow, variantPicker);
      });
    });

    setupOfferVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The native variant-selects/variant-radios path replaces the sticky bar's
  // entire innerHTML from the server on each variant change (see global.js
  // VariantSelects.updateStickyATC) — watch for that and re-attach.
  document.addEventListener('DOMContentLoaded', function () {
    var stickyAtc = document.querySelector('.sticky-atc');
    if (!stickyAtc || typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function () {
      init();
    });
    observer.observe(stickyAtc, { childList: true, subtree: true });
  });
})();
